import React from 'react';
import { Spinner } from '../spinner/Spinner';

export const Loading = () => {
  return (
    <div className="d-f j-c-c a-i-c w-100% h-100%" style={{minHeight: "10rem"}}>
      <Spinner />
    </div>
  )
}